import React from 'react';
const Hagar = (props) => {
    return (
      <div className="membership-card__detail">
        <div className="membership-card__label membership-card__label--inline">HAGAR</div>
        <svg id="icon-check" viewBox="0 0 48 48" width="100%" height="100%">
          <path d="M18.9 35.7 7.7 24.5 9.85 22.35 18.9 31.4 38.1 12.2 40.25 14.35Z"/>
        </svg>
      </div>
    );
}

export default Hagar;